import React from 'react';
import classnames from 'classnames';
import SvgIcon from '@home/components/SvgIcon';

import './index.scss';

interface INewFeatureTipsContentProps extends IBaseProps {
  description?: string | React.ReactElement | null;
  onClose?: () => void;
}

const NewFeatureTipsContent: React.FC<INewFeatureTipsContentProps> = (props) => {
  const { style, className, description, onClose } = props;

  return (
    <div style={style} className={classnames('dbu-new-feature-tips-content', className)}>
      {React.isValidElement(description) && <div className="dbu-new-feature-tips-content__text">{description}</div>}
      {typeof description === 'string' && (
        <div className="dbu-new-feature-tips-content__text" dangerouslySetInnerHTML={{ __html: description }} />
      )}
      <SvgIcon
        className="dbu-new-feature-tips-content__close-icon"
        type="clonse"
        onClick={(e?: React.SyntheticEvent) => {
          e?.stopPropagation();
          onClose?.();
        }}
      />
    </div>
  );
};

export default NewFeatureTipsContent;
